import React from "react";
import Autocomplete from '@mui/lab/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniEntiteetti;

class AdminToiminnotEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.toimintoId == props.rowId;
        });

        this.state = {
            open: false,
            RiviAvain: data[0].riviAvain,
            AsiakasAvain: data[0].asiakasAvain,
            ToimintoId: data[0].toimintoId,
            Entiteetti_Id: data[0].entiteetti_Id,
            Toiminto: data[0].toiminto,
            Oikeustaso: data[0].oikeustaso,
            Aktivoitu: data[0].aktivoitu,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            Active: data[0].active,
            entiteetit: (Object.keys(props.lookupLists.entiteetit).map(function (d) { return { value: d, label: props.lookupLists.entiteetit[d] }; }) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniEntiteetti = this.state.entiteetit.find(({ value }) => value === (this.state.Entiteetti_Id || '').toString());
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            AsiakasAvain: this.state.AsiakasAvain,
            ToimintoId: this.state.ToimintoId,
            Entiteetti_Id: this.state.Entiteetti_Id,
            Toiminto: this.state.Toiminto,
            Oikeustaso: this.state.Oikeustaso,
            Aktivoitu: this.state.Aktivoitu,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
            Active: this.state.Active
        });
        this.setState({ open: false });
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    render() {
        const { dictionary } = this.context;
        const { entiteetit } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={this.state.open} onClose={this.handleClose} maxWidth={false} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{dictionary.AdminToiminnot.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Autocomplete
                            defaultValue={iniEntiteetti}
                            onChange={(event, newValue) => this.handleListChange(event, newValue, 'Entiteetti_Id')}
                            options={entiteetit}
                            getOptionLabel={(option) => option.label}
                            style={{ width: 400 }}
                            renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.AdminToiminnot.Columns[1]} />}
                        />
                        <TextField
                            margin="dense"
                            id="Toiminto"
                            label={dictionary.AdminToiminnot.Columns[2]}
                            type="text"
                            style={{ width: 400 }}
                            value={this.state.Toiminto || ""}
                            onChange={this.handleChange('Toiminto')}
                        />
                        <TextField
                            margin="dense"
                            id="Oikeustaso"
                            label={dictionary.AdminToiminnot.Columns[3]}
                            type="text"
                            style={{ width: 400 }}
                            value={this.state.Oikeustaso || ""}
                            onChange={this.handleChange('Oikeustaso')}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" onClick={this.handleClose}>
                            {dictionary.Close}
                        </Button>
                        <Button variant="contained" color="primary" style={{ color: "#fff" }} onClick={this.handleSave}>
                            {dictionary.Save}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminToiminnotEdit" })(AdminToiminnotEdit);
